import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { situaciones } from '../data/content';
export function SituacionesSection() {
  return <section className="w-full bg-brand-deep px-4 py-9 sm:px-6 sm:py-12" data-id="element-164" data-mp="17810diokfk62">
      <div className="mx-auto max-w-4xl" data-id="element-165" data-mp="1l7914g0dn0cd">
        <div className="mx-auto max-w-xl text-center" data-id="element-166" data-mp="1l67klw0ldln9">
          <h2 className="font-display text-[1.2rem] font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-167" data-mp="1gaa8y309x3gt">
            Cambiar hábitos se siente diferente{' '}
            <span className="text-accent" data-id="element-168" data-mp="oib4stczaud3">cuando dejas de improvisar.</span>
          </h2>
          <p className="mt-2 text-[0.8rem] leading-snug text-violet-200 sm:text-sm" data-id="element-169" data-mp="129fw98670gcc">
            Estas son las situaciones concretas que el método busca resolver.
          </p>
        </div>

        <ul className="mt-5 grid gap-2.5 sm:grid-cols-3 sm:gap-3" data-id="element-170" data-mp="xgwleiyw3zb8">
          {situaciones.map(situacion => <li key={situacion} className="flex h-full gap-2.5 rounded-xl border border-white/15 bg-white/5 p-3 text-left sm:p-4" data-id="element-171" data-mp="4ubqj8j7h52x">
              <QuoteIcon className="mt-px h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-172" data-mp="3ehsszykt4gcs" />
              <p className="text-[0.8rem] leading-snug text-violet-100 sm:text-[0.9rem]" data-id="element-173" data-mp="3o96sw7go7i6g">
                {situacion}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}